module.exports = __webpack_public_path__ + "img/camera-add.8f3f26a0.png";